/**
 * @generated SignedSource<<7f807e42d0e39d50b63bee1c65ed482b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutShippingAddressListWrapper_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutAddShippingAddress_buyer" | "CheckoutShippingAddressList_buyer">;
  readonly " $fragmentType": "CheckoutShippingAddressListWrapper_buyer";
};
export type CheckoutShippingAddressListWrapper_buyer$key = {
  readonly " $data"?: CheckoutShippingAddressListWrapper_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutShippingAddressListWrapper_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutShippingAddressListWrapper_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutShippingAddressList_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutAddShippingAddress_buyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "bb0e55a98769cda83db2604e02022b00";

export default node;
